"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiumicello-villa-vicentina": {
    "1abe78b6": [{
      "hkey": "79cf132d",
      "slug": "borgo-candeletis",
      "name": "Borgo Candeletis",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-candaletis": [{
      "hkey": "79cf132d",
      "slug": "borgo-candeletis",
      "name": "Borgo Candeletis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ca3ae518": [{
      "hkey": "5e42cca2",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "san-antonio": [{
      "hkey": "5e42cca2",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7c725f2e": [{
      "hkey": "4759973a",
      "slug": "fiumicello-villa-vicentina",
      "name": "Fiumicello Villa Vicentina",
      "primary": true,
      "skipSearch": false
    }],
    "fiumicello": [{
      "hkey": "4759973a",
      "slug": "fiumicello-villa-vicentina",
      "name": "Fiumicello Villa Vicentina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;